/**
 * Ceil a number to 1 decimal place.
 * This is used to display percentages.
 *
 * @example
 * ceilOneDecimal(12.345) // returns 12.4
 * ceilOneDecimal(70.333) // returns 70.4
 * ceilOneDecimal(0) // returns 0
 * ceilOneDecimal(0.04) // returns 0.1
 * ceilOneDecimal(0.00) // returns 0
 * ceilOneDecimal(1.00) // returns 1
 * ceilOneDecimal(1.01) // returns 1.1
 * ceilOneDecimal(1.9) // returns 1.9
 **/
export const ceilOneDecimal = (value: number) =>
    Math.ceil(value * 10) / 10 || 0;
